import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";

export default function PaymentReturn() {
  const [status, setStatus] = useState("checking");
  const nav = useNavigate();
  const { checkAuth } = useAuth();
  const attempts = useRef(0);

  useEffect(() => {
    const sessionId = new URLSearchParams(window.location.search).get("session_id");
    if (!sessionId) { setStatus("error"); return; }
    const poll = async () => {
      if (attempts.current >= 6) { setStatus("timeout"); return; }
      attempts.current++;
      try {
        const r = await api.get(`/checkout/status/${sessionId}`);
        if (r.data.payment_status === "paid") { setStatus("success"); checkAuth(); return; }
        if (r.data.status === "expired") { setStatus("error"); return; }
        setTimeout(poll, 2000);
      } catch { setTimeout(poll, 2000); }
    };
    poll();
  }, [checkAuth]);

  return (
    <div className="max-w-lg mx-auto px-6 py-32 text-center">
      {status === "checking" && (<><Loader2 className="w-14 h-14 text-navy animate-spin mx-auto mb-6" /><h1 className="font-serif text-3xl font-bold text-navy">Verifica del pagamento...</h1><p className="text-slate-500 mt-3">Attendere qualche istante.</p></>)}
      {status === "success" && (<><CheckCircle2 className="w-16 h-16 text-emerald mx-auto mb-6" /><h1 className="font-serif text-3xl font-bold text-navy">Abbonamento attivato!</h1><p className="text-slate-500 mt-3 mb-8">Grazie. Ora hai accesso a tutti i contenuti premium.</p><button onClick={() => nav("/episodi")} data-testid="payment-success-cta" className="bg-navy text-white rounded-full px-8 py-3 font-medium hover:bg-petrol">Vai agli episodi</button></>)}
      {(status === "error" || status === "timeout") && (<><XCircle className="w-16 h-16 text-red-500 mx-auto mb-6" /><h1 className="font-serif text-3xl font-bold text-navy">Pagamento non completato</h1><p className="text-slate-500 mt-3 mb-8">Qualcosa è andato storto. Riprova.</p><button onClick={() => nav("/abbonamenti")} className="bg-navy text-white rounded-full px-8 py-3 font-medium hover:bg-petrol">Torna agli abbonamenti</button></>)}
    </div>
  );
}
